import { endpoints } from "./endpoints/endpoints";

export enum MachineServiceAction {
  GET_MACHINE_TYPE = "getMachineType",
  GET_OUTLET = "getOutlet",
  SEARCH = "search",
  UPDATE = "update",
  DELETE = "delete",
  ADD = "add",
}

export default async function MachineService(
  action: string,
  request: any,
  csrf: string
) {
  let url = "";
  switch (action) {
    case MachineServiceAction.GET_MACHINE_TYPE:
      url = endpoints.machine.getMachineType;
      break;
    case MachineServiceAction.ADD:
      url = endpoints.machine.submit;
      break;
    case MachineServiceAction.UPDATE:
      url = endpoints.machine.submit;
      break;
    case MachineServiceAction.DELETE:
      url = endpoints.machine.delete;
      break;
    case MachineServiceAction.SEARCH:
      url = endpoints.machine.search;
      break;
    case MachineServiceAction.GET_OUTLET:
      url = endpoints.machine.getOutlet;
      break;
    default:
      url = "";
  }
  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-XSRF-TOKEN": csrf,
    },
    body: JSON.stringify(request),
  });

  return response.json();
}
